<script lang="ts">
  import { createEventDispatcher } from 'svelte'
  import Button from './Button.svelte'

  export let visible = false
  export let persistent = false
  export let dismiss = true

  const dispatch = createEventDispatcher<{
    toggleVisible: { visible: boolean }
  }>()

  function dismissDialog() {
    if (!persistent) {
      visible = false

      dispatch('toggleVisible', {
        visible,
      })
    }
  }

  function handleKeydown(event: KeyboardEvent) {
    if (visible && event.key === 'Escape') {
      dismissDialog()
    }
  }
</script>

<svelte:window on:keydown={handleKeydown} />
<div class="container" class:visible role="dialog">
  <div
    role="button"
    tabindex="0"
    class="scrim"
    on:click={dismissDialog}
    on:keydown={handleKeydown}
  ></div>
  <div class="dialog-container">
    {#if dismiss}
      <div class="dismiss">
        <Button
          icon="ph-x"
          variant="text"
          on:click={dismissDialog}
          rounded
          type="button"
        />
      </div>
    {/if}
    {#if $$slots.title}
      <slot name="title" />
    {/if}
    <slot name="content" />
    {#if $$slots.actions}
      <slot name="actions" />
    {/if}
  </div>
</div>

<style lang="scss">
  @use '@bond/assets/css/breakpoints';

  .container {
    position: fixed;
    box-sizing: border-box;
    display: flex;
    justify-content: center;
    align-items: center;
    left: 0;
    top: 0;
    width: 100%;
    height: 100%;
    visibility: hidden;
    z-index: 16;

    &.visible {
      visibility: visible;
    }

    .scrim {
      position: absolute;
      box-sizing: border-box;
      left: 0;
      top: 0;
      width: 100%;
      height: 100%;
      background-color: rgba(0, 0, 0, 0.32);
      z-index: 1;
    }

    .dialog-container {
      position: relative;
      box-sizing: border-box;
      display: flex;
      flex-direction: column;
      gap: 1em;
      width: calc(100% - 1em);
      max-width: 800px;
      max-height: calc(100% - 1.5em);
      margin: 1.5em 1em;
      padding: 1.5em;
      background-color: var(--dialog-background-color, var(--color-surface));
      border-radius: 0.5em;
      z-index: 2;
      box-shadow:
        0 11px 15px -7px rgba(0, 0, 0, var(--box-shadow-opacity-1, 0.2)),
        0 24px 38px 3px rgba(0, 0, 0, var(--box-shadow-opacity-2, 0.14)),
        0 9px 46px 8px rgba(0, 0, 0, var(--box-shadow-opacity-3, 0.12));

      .dismiss {
        position: absolute;
        top: 1em;
        right: 1em;
      }

      :global([slot='title']) {
        margin: 0;
      }

      :global([slot='content']) {
        margin: 0;
        overflow-y: auto;
      }

      :global([slot='actions']) {
        display: flex;
        justify-content: flex-end;
        gap: 1em;

        @media screen and (max-width: breakpoints.$breakpoint-sm) {
          flex-direction: column;

          :global(button) {
            width: 100%;
            max-width: 100%;
          }
        }
      }
    }
  }
</style>
